import { render, staticRenderFns } from "./training-access-wap.vue?vue&type=template&id=730a32ac"
import script from "./training-access-wap.vue?vue&type=script&lang=js"
export * from "./training-access-wap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports